import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSignOut } from '@hooks/use-sign-out';

/**
 * Topbar profile avatar with a dropdown menu — switch account (back to the
 * root partner/user switcher) or sign out.
 */
export function UserMenu() {
  const navigate = useNavigate();
  const signOut = useSignOut();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;

    const onPointerDown = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false);
    };

    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  const switchAccount = () => {
    setOpen(false);
    navigate('/');
  };

  const logout = () => {
    setOpen(false);
    signOut();
    navigate('/auth');
  };

  return (
    <div className="v2-topbar-user" ref={ref}>
      <button
        type="button"
        className="v2-topbar-avatar"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label="Benutzermenü"
        onClick={() => setOpen((value) => !value)}
      >
        A
      </button>

      {open && (
        <div className="v2-user-menu" role="menu">
          <button
            type="button"
            role="menuitem"
            className="v2-user-menu-item"
            onClick={switchAccount}
          >
            Account wechseln
          </button>
          <button
            type="button"
            role="menuitem"
            className="v2-user-menu-item"
            onClick={logout}
          >
            Abmelden
          </button>
        </div>
      )}
    </div>
  );
}
